const getDocumentReferenceWithBoundId = (collectionReference, document) =>
  !document.id ? collectionReference.doc() : collectionReference.doc(document.id);

export default getDocumentReferenceWithBoundId;
